// extracted by mini-css-extract-plugin
export default {"radioButton":"AudioStickerForm_radioButton_IR3gf"};